module.exports = __webpack_public_path__ + "static/media/contact.802b27e1.jpg";